import { useMemo } from 'react';

import dateFormat from 'dateformat';

import { renderInfinityChannels } from '@components/Product/Pricelists/functions';
import { BootstrapTable } from '@components/Table/Table';

export const CapacityPstnTariffTable = ({ data, isLoading }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Country',
        accessor: 'country',
      },
      {
        Header: 'Area',
        accessor: 'area',
      },
      {
        Header: 'Type',
        accessor: 'did_type',
      },
      {
        Header: 'Type of caller',
        accessor: 'nature',
      },
      {
        Header: 'PSTN Inbound Plan',
        accessor: 'pstn_plan',
      },
      {
        Header: 'Rate Type',
        accessor: 'rate_type',
      },
      {
        Header: 'NRC',
        accessor: 'nrc_number',
      },
      {
        Header: 'MRC',
        accessor: 'mrc_number',
      },
      {
        Header: '# dflt',
        accessor: 'default_channels',
        Cell: renderInfinityChannels,
      },
      {
        Header: '# max',
        accessor: 'max_channels',
        Cell: renderInfinityChannels,
      },
      {
        Header: 'NRC',
        accessor: 'nrc_channels',
      },
      {
        Header: 'MRC',
        accessor: 'mrc_channels',
      },
      {
        Header: 'Call setup',
        accessor: 'setup_cost',
      },
      {
        Header: 'Price Per Minute',
        accessor: 'price_per_minute',
      },
      {
        Header: 'Max Group CH',
        accessor: 'max_shared_channels',
      },
      {
        Header: 'NRC Group CH',
        accessor: 'shared_channel_nrc',
      },
      {
        Header: 'MRC GROUP <10',
        accessor: 'shared_channel_mrc_lt_10',
      },
      {
        Header: 'MRC Group 10-100',
        accessor: 'shared_channel_mrc_10_to_100',
      },
      {
        Header: 'MRC Group 100+',
        accessor: 'shared_channel_mrc_gt_100',
      },
      {
        Header: 'Billing Method',
        accessor: 'billing_method',
      },
      {
        Header: 'Date Active',
        accessor: 'date_active',
        Cell: ({ value }) => {
          if (!value) {
            return null;
          }
          const date = new Date(value);
          return dateFormat(date, 'defaultDate');
        },
        setMinWidth: '90px',
      },
      {
        Header: 'PSTN Outbound Plan',
        accessor: 'pstn_outbound_plan',
      },
      {
        Header: 'Change',
        accessor: 'description',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        striped: true,
        className: 'normalFontSize',
      })}
      isLoading={isLoading}
    />
  );
};

export const MeteredPstnTariffTable = ({ data, isLoading }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Country',
        accessor: 'country',
      },
      {
        Header: 'Area',
        accessor: 'area',
      },
      {
        Header: 'Type',
        accessor: 'did_type',
      },
      {
        Header: 'Type of caller',
        accessor: 'nature',
      },
      {
        Header: 'PSTN Inbound Plan',
        accessor: 'pstn_plan',
      },
      {
        Header: 'NRC',
        accessor: 'nrc_number',
      },
      {
        Header: 'MRC',
        accessor: 'mrc_number',
      },
      {
        Header: '# dflt',
        accessor: 'default_channels',
        Cell: renderInfinityChannels,
      },
      {
        Header: '# max',
        accessor: 'max_channels',
        Cell: renderInfinityChannels,
      },
      {
        Header: 'NRC',
        accessor: 'nrc_channels',
      },
      {
        Header: 'MRC',
        accessor: 'mrc_channels',
      },
      {
        Header: 'Call setup',
        accessor: 'setup_cost',
      },
      {
        Header: 'Price Per Minute',
        accessor: 'price_per_minute',
      },
      {
        Header: 'Billing Method',
        accessor: 'billing_method',
      },
      {
        Header: 'Date Active',
        accessor: 'date_active',
        Cell: ({ value }) => {
          if (!value) {
            return null;
          }
          const date = new Date(value);
          return dateFormat(date, 'defaultDate');
        },
        setMinWidth: '90px',
      },
      {
        Header: 'PSTN Outbound Plan',
        accessor: 'pstn_outbound_plan',
      },
      {
        Header: 'Change',
        accessor: 'description',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        striped: true,
        className: 'normalFontSize',
      })}
      isLoading={isLoading}
    />
  );
};
